/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Road_Dude_Faq_Format_QInputs */

const en_road_dude_faq_format_q = /** @type {(inputs: Road_Dude_Faq_Format_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What aspect ratio works for TikTok, Reels and Shorts?`)
};

const zh_road_dude_faq_format_q = /** @type {(inputs: Road_Dude_Faq_Format_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发短视频时用什么画幅？`)
};

/**
* | output |
* | --- |
* | "What aspect ratio works for TikTok, Reels and Shorts?" |
*
* @param {Road_Dude_Faq_Format_QInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const road_dude_faq_format_q = /** @type {((inputs?: Road_Dude_Faq_Format_QInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Road_Dude_Faq_Format_QInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_road_dude_faq_format_q(inputs)
	return zh_road_dude_faq_format_q(inputs)
});
export { road_dude_faq_format_q as "road_dude.faq.format.q" }